<template>
	<div>
		<ol class="px-8 py-2 fontS14" v-if="orderSummaryInfo">
			<li
				class="py-2 fontAvenirBold"
				v-for="product in orderSummaryInfo.details"
				:key="product.id"
			>
				<div class="d-flex wrap space-between">
					<div class="flex-50">
						<span>{{product.description}}</span>
					</div>
					<div class="flex-50 d-flex space-between">
						<span class="fontAvenir">Cantidad: {{product.quantity}}</span>
						<span class="fontS16 product-price">{{getCurrencySymbol}} {{product.salePrice | priceFormat}}</span>
					</div>
				</div>
			</li>
		</ol>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
	name: 'ordered-products',
	computed: {
		...mapGetters([
			'getCurrencySymbol',
			'orderSummaryInfo',
		]),
	},
};
</script>
<style lang="scss" scoped>
	ol {
		border: 0.1rem solid color(borderGreyMax);
		border-radius: 0.8rem;

		li {
			border-bottom: 0.1rem solid color(borderGreyMax);
		}

		li:last-child {
			border: none;
		}
	}

	.product-price {
		color: color(orderNumber);
	}
</style>



// WEBPACK FOOTER //
// orderedProducts.vue?6ae3effc